import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useStaticQuery, graphql } from "gatsby"
import FeatureCarousel from "../components/FeatureCarousel/FeatureCarousel"
import { ThreeTeaserComponent } from "../components/Teaser"
import { FourTeaserComponent } from "../components/Teaser"
import { TextCTAModule } from "components/TextCTAModule"
import { TwoColumnTeasers } from "components/TwoColumnTeasers"
import WhyModule from "../components/WhyModule/WhyModule"
import { SubsitePageWrapper } from "components/ProjectStyles"
import { StoriesTeaserAndCTA } from "../components/StoriesTeaserAndCTA"
import { DividerLines } from "../components/DividerLines"

const SubsitePage = () => {
  const ImageQuery = useStaticQuery(
    graphql`
      query {
        fourTeaserImages: allFile(
          filter: { absolutePath: { regex: "/four-teaser-images/" } }
          sort: { fields: [name], order: ASC }
        ) {
          edges {
            node {
              id
              name
              childImageSharp {
                fluid(maxWidth: 1400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        australian: file(relativePath: { eq: "australian-student.png" }) {
          childImageSharp {
            fluid(maxWidth: 600, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        international: file(
          relativePath: { eq: "international-students.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 600, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `
  )

  return (
    <Layout
      subsite
      site="study"
      headerTitle="The Knowledge Capital"
      headerText="Rated in the Top 25 in the world by QS Best Student Cities, living and studying in Canberra means you’ll enjoy a high quality of life in a city with one of the best educated work forces and lowest unemployment rates in Australia."
    >
      <SEO title="Subsite" />
      <SubsitePageWrapper>
        <TwoColumnTeasers
          data={[
            {
              title: "Australian Students",
              excerpt:
                "Find information for Australian residents looking to study in the nation’s capital.",
              link: "/",
              img: ImageQuery.australian.childImageSharp.fluid,
            },
            {
              title: "International Students",
              excerpt:
                "Everything you need to know so you can start planning for living and studying in Canberra.",
              link: "/",
              img: ImageQuery.international.childImageSharp.fluid,
            },
          ]}
        />
        <WhyModule />
        <FeatureCarousel />
        <DividerLines/>
        <FourTeaserComponent
          mainTitle="Where you can study"
          mainExcerpt="When you choose to study in Canberra, you choose Australia’s best university town and the opportunity to earn a first-class education that is recognised around the world."
          fourColumns
          img={ImageQuery.fourTeaserImages.edges}
          data={[
            {
              title: "Universities",
              link: "/",
              label: "Read more",
            },
            {
              title: "Vocational Colleges",
              link: "/",
              label: "Read more",
            },
            {
              title: "English Language Teaching Centres",
              link: "/",
              label: "Read more",
            },
            {
              title: "Schools",
              link: "/",
              label: "Read more",
            },
          ]}
        />
        <StoriesTeaserAndCTA />
        <TextCTAModule />
        <ThreeTeaserComponent
          mainTitle="More information"
          img={ImageQuery.fourTeaserImages.edges}
          data={[
            {
              title: "Lifestyle",
              excerpt:
                "The ultimate work/life balance with access to world-class facilities, stunning natural surrounds and great career opportunities.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Housing & Cost of Living",
              excerpt:
                "A home is the foundation for your life in Canberra. Learn more about the areas you want to live in and options to suit you and your family.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Business in Canberra",
              excerpt:
                "There’s no better place to do business. This is where key decision makers meet, negotiations take place and brilliant possibilities come to life.",
              link: "/",
              label: "Find out more",
            },
          ]}
        />
      </SubsitePageWrapper>
    </Layout>
  )
}

export default SubsitePage
